
'use strict';

/**
 get history tracking by rut
 **/
function getHistoryTracking() {
   $(document).ready(function () {
      const $input = $('#rut-input');
      const $button = $('#search-btn');

      $button.prop('disabled', true); // Deshabilita al inicio

      $input.on('input', function () {
          if ($input.val() !== '') {
              $('#search-btn').addClass('search-btn-active');
              $button.prop('disabled', false);
          } else {
              $button.prop('disabled', true);
          }

      let currentRut = $('#orderTrackingContainer').attr("id-rut");

      if (currentRut && currentRut  === $input.val()) {
          $('#search-btn').removeClass('search-btn-active');
          $button.prop('disabled', true);
      }

      $('.status-timeline').each(function () {
      var $detail = $(this).find('.detail');
      var $timeline = $(this).find('.timeline-container');

      if (!$detail.parent().hasClass('accordion-content')) {
        $detail.add($timeline).wrapAll('<div class="accordion-content"></div>');
      }
    });
  });


  $('.status-timeline .accordion-header').on('click', function () {
    var $container = $(this).closest('.status-timeline');
    $container.toggleClass('active');
  });

    });
}

module.exports = {
    getHistoryTracking: getHistoryTracking
};